export const saveInLocalStorage = (storageKey, value) => {
  return localStorage.setItem(storageKey, value);
};

export const getItemFromLocalStorage = (storageKey) => {
  return localStorage.getItem(storageKey);
};
